import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/az.ts
var add = "əlavə edin";
var remove = "çıxarmaq";
var removeAll = "Hamısını silin";
var incomplete = "Üzr istəyirik, bütün sahələr düzgün doldurulmayıb.";
var submit = "Təqdim et";
var noFiles = "Heç bir fayl seçilməyib";
var moveUp = "yuxarı hərəkət";
var moveDown = "Aşağı hərəkət";
var isLoading = "Yükləmə...";
var loadMore = "Daha çox yüklə";
var next = "Növbəti";
var prev = "Əvvəlki";
var addAllValues = "Bütün dəyərləri əlavə edin";
var addSelectedValues = "Seçilmiş dəyərləri əlavə edin";
var removeAllValues = "Bütün dəyərləri sil";
var removeSelectedValues = "Seçilmiş dəyərləri sil";
var chooseDate = "Tarixi seçin";
var changeDate = "Tarixi dəyişdirin";
var close = "Bağlayın";
var open = "Açıq";
var accepted = function({
  name
}) {
  return `${name} qəbul edin.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} sonra olmalıdır.`;
  }
  return `${sentence(name)} gələcəkdə olmalıdır.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} yalnız əlifba sırası simvollarından ibarət ola bilər.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} yalnız hərf və rəqəmlərdən ibarət ola bilər.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} yalnız hərflərdən və boşluqlardan ibarət ola bilər.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} əlifba sırası simvolları ehtiva etməlidir.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} hərfləri və ya nömrələri ehtiva etməlidir.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} hərfləri və ya boşluqları ehtiva etməlidir.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} simvolu ehtiva etməlidir.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} böyük olmalıdır.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} kiçik olmalıdır.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} nömrələri ehtiva etməlidir.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} simvol olmalıdır.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} yalnız böyük hərfləri ehtiva edə bilər.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} yalnız kiçik hərfləri ehtiva edə bilər.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} əvvəl olmalıdır.`;
  }
  return `${sentence(name)} keçmişdə olmalıdır.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Bu sahə səhv konfiqurasiya edilib və onu təqdim etmək mümkün deyil.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} ${a} və ${b} arasında olmalıdır.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} uyğun gəlmir.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} etibarlı tarix deyil, ${args[0]} formatından istifadə edin`;
  }
  return "Bu sahə səhv konfiqurasiya edilib və onu təqdim etmək mümkün deyil";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} ${date(args[0])} və ${date(args[1])} arasında olmalıdır`;
};
var email = "Etibarlı e-poçt ünvanı daxil edin.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} ilə bitmir.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} icazə verilən dəyər deyil.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} ən azı bir simvol olmalıdır.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} ${max2} simvoldan kiçik və ya ona bərabər olmalıdır.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ${max2} simvol uzunluğunda olmalıdır.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} ${min2} simvoldan böyük və ya ona bərabər olmalıdır.`;
  }
  return `${sentence(name)} ${min2} və ${max2} simvol arasında olmalıdır.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} icazə verilən dəyər deyil.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name}-dən çox ola bilməz.`;
  }
  return `${sentence(name)} ${args[0]} dəyərindən kiçik və ya ona bərabər olmalıdır.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Fayl formatlarına icazə verilmir.";
  }
  return `${sentence(name)} aşağıdakı tipdə olmalıdır: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name}-dən az ola bilməz.`;
  }
  return `${sentence(name)} ən azı ${args[0]} olmalıdır.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” icazə verilən ${name} deyil.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} rəqəm olmalıdır.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" və ya ")} tələb olunur.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} tələb olunur.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} ilə başlamır.`;
};
var url = function() {
  return `Xahiş edirik, düzgün URL daxil edin.`;
};
var invalidDate = "Seçilmiş tarix etibarsızdır.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var az_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, az_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=az.mjs.map